import axios from "axios";

export default {
	async all(params, instanceId) {
		let result = await axios.get(
			`/api/v1/instances/${instanceId}/actions`,
			{
				params: params
			}
		);
		return result.data.data;
	},
	async find(id, instanceId, params) {
		let result = await axios.get(
			`/api/v1/instances/${instanceId}/actions/${id}`,
			{
				params: params
			}
		);
		return result.data.data;
	},
	async create(payload, instanceId) {
		let result = await axios.post(
			`/api/v1/instances/${instanceId}/actions`,
			payload
		);
		return result.data.data;
	},
	async update(payload, instanceId, id) {
		let result = await axios.put(
			`/api/v1/instances/${instanceId}/actions/${id}`,
			payload
		);
		return result.data.data;
	},
	async delete(instanceId, id) {
		let result = await axios.delete(
			`/api/v1/instances/${instanceId}/actions/${id}`
		);
		return result.data.data;
	}
}
